<template>
  <!-- Error banner -->
  <v-banner single-line transition="slide-y-transition" class="banner mt-5">
    <v-avatar slot="icon">
      <v-icon color="red" large>warning</v-icon>
    </v-avatar>
    <div class="text-start">{{ this.errorMessage }}</div>

    <!-- <template v-slot:actions='{ dismiss }'>
      <v-btn
        text
        color='red'
        @click='{
        retryAfterError();
        dismiss();
      }'
      >{{ $translate('TAKE_AWAY') }}</v-btn>
    </template> -->
  </v-banner>
</template>

<script>
export default {
  name: 'ErrorCard',
  props: ['functionName', 'errorMessage'],
  methods: {
    retryAfterError() {
      // Emitting the function received from parent component to recall correct function
      this.$emit(this.functionName);
    },
  },
};
</script>

<style lang="scss" scoped>
.banner {
  width: 100%;
  color: red !important;
}
</style>
